const Image = ({ src, style = {}, width, height, key = null, onClick = null, defer = true, className = null, alt = "Icon", ...props }) => {
  return (
    <>
      {/* {defer ? (
        <img src={src} style={style} key={key} onClick={onClick} className={className} width={width} height={height} alt={alt} loading="lazy" />
      ) : (
        <img src={src} style={style} key={key} onClick={onClick} className={className} width={width} height={height} alt={alt} />
      )} */}
       <img src={src} style={style} key={key} onClick={onClick} className={className} width={width} height={height} alt={alt} loading={defer ? "lazy" : "eager"} />
    </>
  )
}
export default Image
